import api from "PFCore/api";
import { decamelizeDesiredKeys } from "PFCore/helpers/decamelize_desired_keys";

import { MarketplaceActivitiesParams, MarketplaceActivitiesResponse } from "./marketplace.types";

export const fetchMarketplaceSavedActivities = (params: MarketplaceActivitiesParams) =>
  api<MarketplaceActivitiesResponse>({
    url: "marketplace/saved",
    params
  }).then((res) => decamelizeDesiredKeys<MarketplaceActivitiesResponse>(res, ["entries", "meta.filters"])); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
